
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import SearchPageComponent from "../../src/containers/SearchPage";
import Fetch from "./../../libs/fetch";
import { LISTING_URL, HOST } from "./../../store/api";
import BrandConstants from "../../brands/constants";
import { REVALIDATE } from "../../config/serverConfig";
import { CONDO_FOR_RENT_PAGE_ROUTE } from "../../src/config/routes";

export default function SearchPage(props) {
  return <SearchPageComponent {...props} />;
}

//export const config = { amp: 'hybrid' };

export async function getStaticPaths() {
  const paths = BrandConstants.cities.map((city) => ({
    params: { city: city.value },
  }));

  return { paths, fallback: "blocking" };
}

 async function _getStaticProps({ params }) {
  const query = { propertyType: "CONDO", type: "rent", city: params.city };
  const listingsData = await Fetch({
    url: `${HOST}${LISTING_URL}`,
    method: "GET",
    headers: null,
    queryParams: query,
  });

  return {
    props: {
      listingsData,
      propertyType: "CONDO",
      type: "rent",
      hideFooter: true,
      canonicalURL: `/${params.city}${CONDO_FOR_RENT_PAGE_ROUTE}`,
    },
    revalidate: REVALIDATE,
  };
}


    export async function getStaticProps(ctx) {
        let res = _getStaticProps(ctx)
        if(typeof res.then === 'function') res = await res
        return {
          
          ...res,
          props: {
            ...(res.props || {}),
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/[city]/condo-for-rent',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  